import React, { useCallback, useMemo, useState } from 'react';
import { DateRangeDropdown } from '@common-fe/common-fe';
import dayjs from 'dayjs';

import { DEFAULT_DATE_FORMAT } from '@/common/constants';

import useParticipantActivityRangeInputFeatureFlag from '../hooks/useParticipantActivityRangeInputFeatureFlag';

interface Props {
  testId?: string;
  disabled?: boolean;
  asDate: Date | null;
  onSetAsDate: (value: Date | null) => void;
}

const ParticipantAccountActivityRange: React.FC<Props> = ({
  disabled,
  testId = 'activity-range',
  onSetAsDate,
  asDate = null,
}) => {
  const isAvaialbe = useParticipantActivityRangeInputFeatureFlag();
  const isToday = useMemo(() => {
    const today = dayjs().format(DEFAULT_DATE_FORMAT);
    if (asDate) {
      return dayjs(asDate).format(DEFAULT_DATE_FORMAT) === today;
    }
    return false;
  }, [asDate]);
  const [startDate, setStartDate] = useState(asDate);
  const [endDate, setEndDate] = useState(asDate);

  const onChange = useCallback(
    (dates: [Date | null, Date | null]) => {
      const today = dayjs().startOf('day');
      const todayDate = today.toDate();

      const [start, end] = dates;
      if (!start) {
        setStartDate(todayDate);
        setEndDate(todayDate);
        onSetAsDate(todayDate);
      } else {
        setStartDate(start);
        setEndDate(end);
        onSetAsDate(start);
      }
    },
    [onSetAsDate]
  );
  if (!isAvaialbe) {
    return null;
  }
  return (
    <DateRangeDropdown
      prefix="As of date:"
      defaultTitle="Today"
      customTitle={isToday ? 'Today' : undefined}
      isSingleDateMode
      disabled={disabled}
      testId={testId}
      isTwoCalendars={false}
      onChange={onChange}
      startDate={startDate}
      maxDate={dayjs()}
      endDate={endDate}
      clearMode={false}
    />
  );
};

export default ParticipantAccountActivityRange;
